<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <h1 class="title mb-0">{{ pageTitleValue }}</h1>
      </div>
      <div class="col-12">
        <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
          <ol class="breadcrumb breadcrumb-links">
            <li class="breadcrumb-item">
              <a> <i class="fas fa-home"> </i> </a>
            </li>
            <li class="breadcrumb-item">
              <a [routerLink]="pageLinkValue"> {{ pageTitleValue }} </a>
            </li>
            <li aria-current="page" class="breadcrumb-item active">
              {{ currentPageValue }}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</div>
